var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareBgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 31,
    rx: 3.5,
    fill: "#121B18"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 31,
    rx: 3.5,
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9987 20.0028H17.4367C15.722 20.0001 14.332 18.6621 14.332 17.0114C14.332 15.3614 15.722 14.0234 17.4367 14.0234C17.6987 12.8488 18.6327 11.8901 19.8867 11.5081C21.14 11.1268 22.524 11.3794 23.516 12.1748C24.508 12.9681 24.9574 14.1794 24.696 15.3541H25.356C26.276 15.3541 27.0714 15.8961 27.4427 16.6808M25.6654 18.6668V22.6668M25.6654 22.6668L27.6654 20.6668M25.6654 22.6668L23.6654 20.6668",
    stroke: "#00FFE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBgDark);
export default __webpack_public_path__ + "static/media/shareBgDark.ee122af9196580b77e47f024e630dc6a.svg";
export { ForwardRef as ReactComponent };